import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import StarIcon from '@mui/icons-material/Star';
import { Box } from '@mui/material';

const PublishedFormatter = ({ value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
    {!!value && <StarIcon sx={{ color: '#ffc107', fontSize: 20 }} />}
  </Box>
);

export const PublishedTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={PublishedFormatter}
    {...props}
  />
);
